var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewConvMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1365",
    "data-name": "Rectangle 1365",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Write_a_message_mobile",
    "data-name": "Write a message mobile",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4171",
    "data-name": "Group 4171",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M13.591,13.214l9.027-9.06a1.99,1.99,0,1,0-2.81-2.82L10.76,10.414a1.345,1.345,0,0,0-.327.539l-1.1,3.434a.128.128,0,0,0,.142.155L13,13.558A1.331,1.331,0,0,0,13.591,13.214Z",
    transform: "translate(0.048 0.007)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M20.223,12.279v5.092a5.83,5.83,0,0,1-5.819,5.84H6.569A5.83,5.83,0,0,1,.75,17.371V9.506a5.83,5.83,0,0,1,5.819-5.84h6.157",
    transform: "translate(0.004 0.033)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConvMobileIcon);
export default __webpack_public_path__ + "static/media/new-conv-mobile-icon.3d33dc3366ebe4edaf6b2211e5114122.svg";
export { ForwardRef as ReactComponent };